import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Checkbox,
  VStack,
  Textarea,
} from '@chakra-ui/react';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import {
  config,
  CONVERSATION_TYPES,
  MESSAGE_FEEDBACK_CONFIG,
} from '../../config';

const MessageFeedbackModal = ({
  message,
  isOpen,
  onClose,
  feedbackType,
  onFeedbackSubmitted,
}) => {
  const [feedbackReasons, setFeedbackReasons] = useState(new Set());
  const [feedbackText, setFeedbackText] = useState('');
  const [isOtherChecked, setIsOtherChecked] = useState(false);
  const { getAccessTokenSilently } = useAuth0();

  // Effect to reset feedback when modal closes
  useEffect(() => {
    if (!isOpen) {
      setFeedbackReasons(new Set());
      setFeedbackText('');
      setIsOtherChecked(false);
    }
  }, [isOpen]);

  const isSendButtonDisabled =
    feedbackReasons.size === 0 ||
    (isOtherChecked && feedbackText.trim() === '');

  const handleCheckboxChange = (event) => {
    const { value } = event.target;
    setFeedbackReasons((prevReasons) => {
      const reasons = new Set(prevReasons);
      if (reasons.has(value)) {
        reasons.delete(value);
      } else {
        reasons.add(value);
      }
      return reasons;
    });
  };

  const handleSubmitMessageFeedback = async () => {
    const accessToken = await getAccessTokenSilently();
    const messageFeedbackData = {
      feedbackType,
      feedbackReasons: Array.from(feedbackReasons),
      feedbackText: feedbackText.length > 0 ? feedbackText : undefined,
      conversationId: message.conversationId,
      conversationType: CONVERSATION_TYPES.PROVIDER,
      botResponse: message.text,
      botResponseMessageId: message.PK + message.SK,
    };
    console.log('submitting messageFeedback: ', messageFeedbackData);
    const response = await axios.post(
      `${config.HTTP_API_URL}/feedback/messages`,
      messageFeedbackData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    onFeedbackSubmitted(message, feedbackType);
    onClose();
  };

  const { title, reasons } = MESSAGE_FEEDBACK_CONFIG[feedbackType];

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent mx={4}>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={4} align='stretch'>
            {reasons.map((reason) => (
              <Checkbox
                key={reason.key}
                value={reason.key}
                onChange={handleCheckboxChange}
                isChecked={feedbackReasons.has(reason.key)}
              >
                {reason.text}
              </Checkbox>
            ))}
            <Textarea
              placeholder='Provide additional feedback (optional)'
              value={feedbackText}
              onChange={(e) => setFeedbackText(e.target.value)}
            />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={onClose}
            mr={3}
            bg='#FFF'
            color='#AE2824'
            borderRadius='3px'
            border='0px solid var(--secondary-red, #AE2824)'
          >
            Cancel
          </Button>
          <Button
            bg='var(--colors-primary-gold, #EC9F24)'
            color='#FFFFFF'
            onClick={handleSubmitMessageFeedback}
            isDisabled={isSendButtonDisabled}
            borderRadius='3px'
          >
            Submit Feedback
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default MessageFeedbackModal;
